<template>
  <div class="is-size-7">
    {{ label }}
    <strong>
      {{ Math.round(quota) | convertFileSizeMo }}
    </strong>
    <span v-if="additionalQuota > 0"
      >( +
      {{ Math.round(additionalQuota) | convertFileSizeMo }}
      )</span
    >
    <span> / {{ maxQuota | convertFileSizeMo }}</span>
    <b-progress :type="barType" format="percent" :value="quota">
      <template #bar>
        <b-progress-bar :value="(quota / maxQuota) * 100" />
        <b-progress-bar
          :value="(additionalQuota / maxQuota) * 100"
          :type="barType"
        />
      </template>
    </b-progress>
  </div>
</template>

<script>
export default {
  name: 'QuotaBar',
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    quota: {
      type: Number
    },
    maxQuota: {
      type: Number
    },
    additionalQuota: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    barType () {
      if (this.quota + this.additionalQuota < 0.5 * this.maxQuota) {
        return 'is-success'
      } else if (this.quota + this.additionalQuota < 0.75 * this.maxQuota) {
        return 'is-warning'
      }
      return 'is-danger'
    }
  }
}
</script>
